import { render } from "./GroFab.vue?vue&type=template&id=0800c335"
import script from "./GroFab.vue?vue&type=script&lang=js"
export * from "./GroFab.vue?vue&type=script&lang=js"
script.render = render

export default script